const Mutations = Object.freeze({
	SET_FORM_FIELDS:
		'inventoryFormModule/formBuilder/mobileAppConfig/SET_FORM_FIELDS',
});

export const Actions = Object.freeze({
	CLEAR: 'inventoryFormModule/formBuilder/mobileAppConfig/CLEAR',
	LOAD: 'inventoryFormModule/formBuilder/mobileAppConfig/LOAD',
	UPDATE_MOBILE_HEADERS:
		'inventoryFormModule/formBuilder/mobileAppConfig/UPDATE_MOBILE_HEADERS',
});

export const Getters = Object.freeze({
	FORM_FIELDS: 'inventoryFormModule/formBuilder/mobileAppConfig/FORM_FIELDS',
});

import { GeneralActions } from '../../../../../actions';
import dataService from '../../../../../../services/data/inventoryFormService';
export default {
	state: {
		formFields: [],
	},
	mutations: {
		[Mutations.SET_FORM_FIELDS](state, items) {
			state.formFields = items;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_FORM_FIELDS, []);
				resolve();
			});
		},
		[Actions.LOAD]({ commit, dispatch }, inventoryFormId) {
			return new Promise((resolve) => {
				let result = [];
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getFormFields(inventoryFormId)
					.then((resp) => {
						result = resp.data;
						commit(Mutations.SET_FORM_FIELDS, resp.data);
					})
					.then(() => {
						resolve(result);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve();
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.UPDATE_MOBILE_HEADERS](
			{ dispatch },
			{ inventoryFormId, formFields }
		) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updateMobileHeaders(inventoryFormId, formFields)
					.then(() => {
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve();
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
	},
	getters: {
		[Getters.FORM_FIELDS]: (state) => {
			if (!state.formFields) return [];
			if (state.formFields.length < 0) return [];
			return JSON.parse(JSON.stringify(state.formFields));
		},
	},
};
